import { render } from "./OrcamentoFinalRepeticao.vue?vue&type=template&id=74509248&scoped=true"
import script from "./OrcamentoFinalRepeticao.vue?vue&type=script&lang=js"
export * from "./OrcamentoFinalRepeticao.vue?vue&type=script&lang=js"

import "./OrcamentoFinalRepeticao.vue?vue&type=style&index=0&id=74509248&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74509248"]])

export default __exports__